let config
let baseConfig = require('./base.config')


if (process.env.CODE_ENV === 'production') {
  config = require('./prod.config')
} else if (process.env.CODE_ENV === 'devbuild') {
  config = require('./dev.config')
} else if (process.env.CODE_ENV === 'mock') {
  config = require('./mock.config')
} else {
  config = require('./dev.config')
}

export default Object.assign({}, config, baseConfig)



// WEBPACK FOOTER //
// ./src/config/index.js